import { fetchGet } from "..";
import { CmsData } from "../../types/cms";

export const getCmsData = async (): Promise<CmsData> => {
  try {
    return await fetchGet("/settings");
  } catch (error) {
    console.error("Error getting CMS data", error.message);
  }
};
